export default "__VITE_ASSET__B2rGd$Tg__"